
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: {},
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop() private item!: any
  
  /// data
  private previewIndex: number = new Date().getTime()
  
}
